<script>
  export let keyword;
  export let onRemove;
</script>

<style>
  div.keyword {
    background-color: var(--revista-blue);
    display: flex;
    align-items: center;
    padding: 10px;
    margin-right: 10px;
    color: white;
    font-size: 13px;
    border-radius: 20px;
    margin-bottom: 20px;
  }

  img {
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin-left: 10px;
  }
</style>

<div class="keyword">
  <span>{keyword}</span>
  <img src="/images/revista/x.svg" alt="Remove Icon" on:click={onRemove} />
</div>
